import { render, staticRenderFns } from "./orderPreviewDialog.vue?vue&type=template&id=edf67aea&"
import script from "./orderPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./orderPreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports